import { Link } from "react-router-dom";
// import img from "../../../../assets/images/paysuccess.png";
import { Icon } from "@iconify/react/dist/iconify.js";
// import "./style.css";
import useStyles from "../../styles";

const Success = () => {
  const classes = useStyles();

  return (
    <div className="pay-redirect">
      <div className={classes.paymentsuccess}>
        <Icon icon="line-md:confirm-circle" width="120" height="120" style={{ color: "#059e49" }} />
        <p>Payment Successful</p>
        <span>Congratulations, your Invoice Payment is Successful</span>
        <Link to="/auth/login">Click here to login</Link>
      </div>
    </div>
  );
};

export default Success;
